import moment from "moment-timezone";

// D8.15.2 — Constantes + helper de ScheduledIndividualMessageModal.

export const getMinScheduledAt = () =>
  moment().add(2, "minutes").format("YYYY-MM-DDTHH:mm");

export const STATUS_CFG = {
  pending:   { label: "Pendiente",   color: "#f59e0b" },
  sending:   { label: "Enviando...", color: "#3b82f6" },
  sent:      { label: "Enviado",     color: "#10b981" },
  completed: { label: "Completado",  color: "#10b981" },
  failed:    { label: "Fallido",     color: "#ef4444" },
  cancelled: { label: "Cancelado",   color: "#9ca3af" },
  paused:    { label: "Pausado",     color: "#f59e0b" },
};

export const RECURRENCE_OPTIONS = [
  { value: "once",    label: "Única vez" },
  { value: "daily",   label: "Diaria" },
  { value: "weekly",  label: "Semanal" },
  { value: "monthly", label: "Mensual" },
  { value: "custom",  label: "Personalizada" },
];

// Variables del sistema disponibles — etiqueta visible → texto inyectado
export const SYSTEM_VARS = [
  { label: "Primer Nombre", value: "{{firstName}}" },
  { label: "Saludo",        value: "{{greeting}}" },
  { label: "Protocolo",     value: "{{protocol}}" },
  { label: "Hora",          value: "{{time}}" },
  { label: "Nombre",        value: "{{name}}" },
  { label: "ID Ticket",     value: "{{ticketId}}" },
];

// ─────────────────────────────────────────────────────────────────────────────
// Estilos
// ─────────────────────────────────────────────────────────────────────────────
